module.exports = __webpack_public_path__ + "img/choice.f1ca9c5c.png";